import { Modal } from 'antd'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../UI/Button'
const {warning} = Modal

function index(props: {customRedirect?: () => void, title?: string}) {

  const history = useNavigate()

  const redirect = () => {
    if(props.customRedirect) return props.customRedirect()
    history(-1)
  }
  const warning = () => {
    Modal.confirm({
      title: 'Are you sure you want to cancel changes?',
      content: props.title || 'If you cancel all changes will be lost and you will be redirected.',
      onOk: () => redirect(),
      cancelText: 'Close',
    });
  };
  return (
    <>
      <Button onClick={warning} type='secondary'>
        <p id="cancel-button">Cancel</p>
      </Button>
    </>

  )
}

export default index